<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div class="decorative-icon">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/menu.svg?alt=media&token=6cc87810-c0f8-41a0-a994-8ca4aa3813cf"
          />
        </div>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <ion-row>
          <ion-col size="12">
            <p
              class="arrow-back-header goal-dropup-padding mt-0 mb-1 ion-text-uppercase thin dark text-sm"
            >
              <ion-icon
                mode="ios"
                name="arrow-dropleft-circle"
                class="mr-1 text-md cursor-pointer"
                color="primary"
                @click="gotoBack"
              ></ion-icon>Objetivo e conquistas
            </p>
            <p class="mt-0 mb-0 green goal-dropup-padding text-xxl ion-text-uppercase">Meu progresso</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="settings-item-top cursor-pointer" @click="gotoEditGoal">
              <ion-item lines="none">
                <ion-label>
                  <p class="mt-0 mb-0 bold dark text-md">Editar objetivo</p>
                  <p class="mt-0 mb-0 thin dark text-sm ion-text-wrap">
                    Seu objetivo atual é
                    <span class="green bold">Emagrecimento</span>
                  </p>
                </ion-label>
                <ion-icon mode="ios" name="arrow-round-forward" slot="end" class="dark"></ion-icon>
              </ion-item>
            </div>
            <div class="points-block mt-4">
              <p class="mb-1 dark thin ion-text-uppercase text-sm">Pontos acumulados</p>
              <p class="mt-0 green bold text-lg">
                {{ profile.data.points }} pontos &#183;
                <span
                  class="thin"
                >Nível: {{ profile.data.level }}</span>
                <br />
                <span class="darkgrey text-sm" v-if="nextLevel">
                  + {{ pointsToNextLevel }} pontos para
                  {{ nextLevel }}
                </span>
              </p>
            </div>
          </ion-col>
        </ion-row>
        <div class="goal-dropup">
          <div class="goal-dropup-padding">
            <p class="mt-4 pl-2 mb-1 dark thin ion-text-uppercase text-md">Minhas conquistas</p>
            <p v-if="numMilestones > 0" class="pl-2 mt-0 mb-3 green text-md">
              Você possui
              <span
                v-if="numMilestones === 1"
                class="green bold"
              >{{ numMilestones }} conquista</span>
              <span v-else class="green bold">{{ numMilestones }} conquistas</span>
            </p>
            <p v-else class="pl-2 mt-0 mb-4 green text-sm">Você ainda não possui conquistas</p>
            <ion-row>
              <ion-col size="12">
                <div :class="milestoneFirstMeal.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left green bold">Desencantei!</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">"Comi" minha primeira refeição.</p>
                    <div v-if="milestoneFirstMeal.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestoneFirstShare.class">
                  <div class="mr-2">
                    <ion-img
                      class="greyscale"
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Ajudando a galera</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Compartilhei uma receita pelo app.</p>
                    <div v-if="milestoneFirstShare.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestoneHealthConnected.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mb-0 text-sm ion-text-left bold">Saúde conectada</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Conectei o Apple ou Google Health.</p>
                    <div v-if="milestoneHealthConnected.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestoneInviteFriend.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Dica de ouro</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">
                      Compartilhei via
                      <span
                        class="bold green cursor-pointer"
                        @click="inviteFriend"
                      >Convidar um amigo</span>.
                    </p>
                    <div v-if="milestoneInviteFriend.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestoneFirstSurvey.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Monitorando</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Atualizei meu peso pela primeira vez.</p>
                    <div v-if="milestoneFirstSurvey.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestoneLostWeight.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Perdi peso!</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Reportei a primeira perda de peso.</p>
                    <div v-if="milestoneLostWeight.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestoneLostFat.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Perdi gordura!</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Reportei a primeira perda de gordura.</p>
                    <div v-if="milestoneLostFat.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestoneBreakfastWeek.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Manhã poderosa</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Café todos os dias por uma semana.</p>
                    <div v-if="milestoneBreakfastWeek.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestoneLunchWeek.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Tarde maravilha</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Almocei todos os dias por uma semana.</p>
                    <div v-if="milestoneLunchWeek.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestoneDinnerWeek.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Noite gostosa</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Jantei todos os dias por uma semana.</p>
                    <div v-if="milestoneDinnerWeek.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestonePerfectDay.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Dia perfeito</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Comi todas as refeições em um dia.</p>
                    <div v-if="milestonePerfectDay.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestonePerfectWeek.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Semana perfeita</p>
                    <p
                      class="mt-0 mb-0 text-sm ion-text-left"
                    >Comi todas as refeições em uma semana.</p>
                    <div v-if="milestonePerfectWeek.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestonePerfect20Days.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">20 dias perfeitos</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Comi todas as refeições por 20 dias.</p>
                    <div v-if="milestonePerfect20Days.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12">
                <div :class="milestonePerfectMonth.class">
                  <div class="mr-2">
                    <ion-img
                      src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/flag_grey.svg?alt=media&token=78f75989-5759-4331-afd3-b03f5750a26d"
                    ></ion-img>
                  </div>
                  <div>
                    <p class="mt-0 mb-0 text-sm ion-text-left bold">Mês perfeito</p>
                    <p class="mt-0 mb-0 text-sm ion-text-left">Comi todas as refeições por 30 dias.</p>
                    <div v-if="milestonePerfectMonth.status" class="share-milestone d-none">
                      <ion-icon mode="ios" name="share" class="white"></ion-icon>
                    </div>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
      </ion-grid>
    </ion-content>
  </ion-app>
</template>

<script>
// capacitor
import { Plugins } from "@capacitor/core";
const { Device } = Plugins;
const { Share } = Plugins;
// firebase
import db from "@/firebase/init";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// component
export default {
  name: "GoalPage",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: true,
      fullPage: true,
      user: store.state.user,
      profile: store.state.profile,
      goal: null,
      nextLevel: null,
      pointsToNextLevel: null,
      numMilestones: 0,
      milestoneFirstMeal: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestoneFirstShare: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestoneHealthConnected: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestoneInviteFriend: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestoneFirstSurvey: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestoneLostWeight: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestoneLostFat: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestoneBreakfastWeek: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestoneLunchWeek: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestoneDinnerWeek: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestonePerfectDay: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestonePerfectWeek: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestonePerfect20Days: {
        status: false,
        class: "milestone milestone-unachieved"
      },
      milestonePerfectMonth: {
        status: false,
        class: "milestone milestone-unachieved"
      }
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    gotoBack() {
      this.$router.push({
        name: "Profile"
      });
    },
    async inviteFriend() {
      const instance = this;
      const userId = instance.profile.id;
      await db
        .collection("users")
        .doc(userId)
        .update({
          milestoneInviteFriend: true
        });
      store.state.profile.data.milestoneInviteFriend = true;
      const info = await Device.getInfo();
      if (info.platform === "ios") {
        let shareRet = await Share.share({
          title: `Olha esse app incrível: Updiet`,
          text:
            "Plano de nutrição inteligente: + 1.500 receitas fáceis, saudáveis e deliciosas :)",
          url: `https://apps.apple.com/us/app/updiet/id1484349177?l=pt#?platform=iphone`,
          dialogTitle: "Compartilhe o Updiet com quem você ama"
        });
      } else if (info.platform === "android") {
        let shareRet = await Share.share({
          title: `Olha esse app incrível: Updiet`,
          text:
            "Plano de nutrição inteligente: + 1.500 receitas fáceis, saudáveis e deliciosas :)",
          url: `https://play.google.com/store/apps/details?id=com.updiet`,
          dialogTitle: "Compartilhe o Updiet com quem você ama"
        });
      } else {
        //
      }
    },
    gotoEditGoal() {
      this.$router.push({
        name: "Edit Goal"
      });
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      // check if subscription is active
      if (!instance.profile.data.subscriptionStatus) {
        this.$router.push({
          name: "Subscribe"
        });
      }
      // get profile
      const userRef = db.collection("users").doc(instance.profile.id);
      const doc = await userRef.get();
      const profile = {
        id: doc.id,
        data: doc.data()
      };
      instance.profile = profile;
      // run checks
      if (instance.profile.data.goal) {
        if (instance.profile.data.goal === "loseWeight") {
          instance.goal = "Emagrecimento";
        } else if (instance.profile.data.goal === "gainMuscles") {
          instance.goal = "Hipertrofia";
        } else {
          instance.goal = "Dieta equilibrada";
        }
      }

      if (instance.profile.data.points < 50) {
        if (instance.profile.data.level !== "beginner") {
          db.collection("users")
            .doc(instance.profile.id)
            .update({
              level: "beginner"
            });
          instance.profile.data.level = "beginner";
        }
      } else if (instance.profile.data.points < 200) {
        if (instance.profile.data.level !== "intermediate") {
          db.collection("users")
            .doc(instance.profile.id)
            .update({
              level: "intermediate"
            });
          instance.profile.data.level = "intermediate";
        }
      } else if (instance.profile.data.points < 500) {
        if (instance.profile.data.level !== "advanced") {
          db.collection("users")
            .doc(instance.profile.id)
            .update({
              level: "advanced"
            });
          instance.profile.data.level = "advanced";
        }
      } else {
        if (instance.profile.data.level !== "expert") {
          db.collection("users")
            .doc(instance.profile.id)
            .update({
              level: "expert"
            });
          instance.profile.data.level = "expert";
        }
      }

      if (instance.profile.data.level) {
        if (instance.profile.data.level === "beginner") {
          instance.profile.data.level = "Iniciante";
          instance.nextLevel = "Intermediário";
          instance.pointsToNextLevel = 50 - instance.profile.data.points;
        } else if (instance.profile.data.level === "intermediate") {
          instance.profile.data.level = "Intermediário";
          instance.nextLevel = "Avançado";
          instance.pointsToNextLevel = 200 - instance.profile.data.points;
        } else if (instance.profile.data.level === "advanced") {
          instance.profile.data.level = "Avançado";
          instance.nextLevel = "Expert";
          instance.pointsToNextLevel = 500 - instance.profile.data.points;
        } else {
          instance.profile.data.level = "Iniciante";
          instance.nextLevel = "Intermediário";
          instance.pointsToNextLevel = 50 - instance.profile.data.points;
        }
      }

      let numMilestones = 0;

      if (instance.profile.data.milestoneFirstMeal) {
        instance.milestoneFirstMeal = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestoneFirstMeal = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestoneFirstShare) {
        instance.milestoneFirstShare = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestoneFirstShare = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestoneHealthConnected) {
        instance.milestoneHealthConnected = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestoneHealthConnected = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestoneInviteFriend) {
        instance.milestoneInviteFriend = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestoneInviteFriend = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestoneFirstSurvey) {
        instance.milestoneFirstSurvey = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestoneFirstSurvey = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestoneLostWeight) {
        instance.milestoneLostWeight = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestoneLostWeight = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestoneLostFat) {
        instance.milestoneLostFat = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestoneLostFat = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestoneBreakfastWeek) {
        instance.milestoneBreakfastWeek = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestoneBreakfastWeek = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestoneLunchWeek) {
        instance.milestoneLunchWeek = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestoneLunchWeek = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestoneDinnerWeek) {
        instance.milestoneDinnerWeek = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestoneDinnerWeek = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestonePerfectDay) {
        instance.milestonePerfectDay = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestonePerfectDay = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestonePerfectWeek) {
        instance.milestonePerfectWeek = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestonePerfectWeek = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestonePerfect20Days) {
        instance.milestonePerfect20Days = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestonePerfect20Days = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      if (instance.profile.data.milestonePerfectMonth) {
        instance.milestonePerfectMonth = {
          status: true,
          class: "milestone milestone-achieved"
        };
        numMilestones += 1;
      } else {
        instance.milestonePerfectMonth = {
          status: false,
          class: "milestone milestone-unachieved"
        };
      }

      instance.isLoading = false;
      instance.numMilestones = numMilestones;
      store.state.profile = profile;
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-app {
  background: var(--bg-color-light) !important;
}

ion-content {
  --background: var(--bg-color-light) !important;
}

ion-grid {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.goal-dropup-padding {
  padding-left: 5vw;
  padding-right: 5vw;
}

.goal-dropup {
  padding-bottom: 50px;
}

.period-selector {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 100%;
  max-width: 250px;
  border-radius: 50px;
  background: #eeeeee;
}

.data-selector {
  position: relative;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 55%;
  max-width: 150px;
  border-radius: 50px;
  background: #eeeeee;
}

.control-item {
  border-radius: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  padding-right: 15px;
  cursor: pointer;
}

.control-item-selected {
  background: white;
  box-shadow: 2px 2px 2px -1px rgba(0, 0, 0, 0.15);
}

.control-item-selected p {
  color: var(--ion-color-primary) !important;
}

.points-block {
  width: 100%;
  padding: 20px;
  border-top: 1px solid var(--ion-color-primary);
  border-bottom: 1px solid var(--ion-color-primary);
  background: white;
  z-index: 1020;
}

.milestone {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border: 2px solid rgb(230, 230, 230);
  border-radius: 10px;
  background: linear-gradient(135deg, var(--bg-color-light), white, white);
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.15);
  padding: 1rem;
  margin: 0.25rem;
}

.milestone-achieved {
  border: 2px solid var(--ion-color-primary);
}

.milestone-achieved p {
  color: var(--ion-color-primary);
}

.milestone-unachieved p {
  color: rgb(164, 164, 164) !important;
}

.milestone ion-img {
  height: 48px;
  width: 48px;
}

.share-milestone {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  top: -8px;
  right: -8px;
  cursor: pointer;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  z-index: 1000;
  background: var(--ion-color-primary);
}

.arrow-back-header {
  display: flex;
  align-items: center;
}

.settings-item-top ion-item {
  --background: white !important;
  --padding-top: 10px !important;
  --padding-bottom: 10px !important;
}

.settings-item ion-item {
  --background: white !important;
  --padding-top: 10px !important;
  --padding-bottom: 10px !important;
}

.settings-item-top {
  border-top: 1px solid var(--ion-color-grey);
  border-bottom: 1px solid var(--ion-color-grey);
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
  z-index: 1010;
}
</style>

<!--
<ion-row>
          <ion-col size="12">
            <div class="goal-menu p-3">
              <div class="period-selector mb-3">
                <div
                  :class="chart.period.week.class"
                  @click="changePeriod('week')"
                >
                  <p class="mt-0 mb-0 text-sm darkgrey bold">Semana</p>
                </div>
                <div
                  :class="chart.period.month.class"
                  @click="changePeriod('month')"
                >
                  <p class="mt-0 mb-0 text-sm darkgrey bold">Mês</p>
                </div>
                <div
                  :class="chart.period.year.class"
                  @click="changePeriod('year')"
                >
                  <p class="mt-0 mb-0 text-sm darkgrey bold">Ano</p>
                </div>
              </div>
              <GoalChart :chartData="chartData" :options="chartOptions" />
              <div class="data-selector mt-3">
                <div :class="chart.data.kcal.class" @click="changeData('kcal')">
                  <p class="mt-0 mb-0 text-sm darkgrey bold">kcal</p>
                </div>
                <div
                  :class="chart.data.points.class"
                  @click="changeData('period')"
                >
                  <p class="mt-0 mb-0 text-sm darkgrey bold">pontos</p>
                </div>
              </div>
            </div>
          </ion-col>
        </ion-row>
-->